<template>
    <div class="row">
        <small class="col-md-12">{{product.title}}</small>
        <small class="col-md-12">{{lineItem.sku}}</small>
        <small class="col-md-12">{{price | currency}}</small>
    </div>
</template>

<script>
  import {currency} from '../../../filters';

  export default {
    name: 'OrderProductDetail',
    props: {
      product: {
        required: true,
        title: {
          required: true,
        },
        handle: {
          required: true,
        },
      },
      lineItem: {
        required: true,
        variant_title: {
          required: true,
        },
        price: {
          required: true,
        },
      },
    },
    filters: {
      currency,
    },
    computed: {
      price() {
        return this.product.variants.find(variant =>
          variant.sku === this.lineItem.sku
        ).price;
      },
    },
  };
</script>
